module.exports = __webpack_public_path__ + "static/media/hackerMusk.342ba978.png";